import React, {useEffect, useRef, useState} from "react";
import {saveTmdbNote} from "../../../../utils/TorresowoBackend";
import auth from "../../../../utils/authentication";
import {FormattedMessage, useIntl} from "react-intl";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {getLastModifiedMessage} from "../../../../utils/utils";
import CustomModalV2 from "../../../shared/custom-modal-v2/custom-modal-v2";
import ButtonV2 from "../../../shared/button-v2/button-v2";

const TmdbNotepad = ({tmdbItem, forceDarkMode, customUrl, onClose = undefined}) => {

    const [note, setNote] = useState(tmdbItem.notes ?? "");
    const [saving, setSaving] = useState(false);
    const [dirty, setDirty] = useState(false);
    const [lastModified, setLastModified] = useState(tmdbItem.notes ? tmdbItem.note_modified_date : null);
    const timeoutRef = useRef(null);
    const location = useLocation();
    const navigate = useNavigate();
    const intl = useIntl();

    const handleCloseModal = () => {
        navigate(-1);
        if (onClose) {
            onClose(note);
        }
    }

    useEffect(() => {
        if (!dirty) {
            return;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        timeoutRef.current = setTimeout(() => {
            setSaving(true);
            saveNote().then(() => {
                setSaving(false);
                if (!note?.length) {
                    setLastModified(null);
                } else {
                    setLastModified(new Date().toISOString());
                }
            });
        }, 500);
    }, [note, dirty]);

    const saveNote = () => {
        return saveTmdbNote({
            uid: auth.currentUser.uid,
            tmdbId: tmdbItem.show_id ?? tmdbItem.id,
            season_number: tmdbItem.season_number ?? (tmdbItem.isMovie ? -1 : -2),
            episode_number: tmdbItem.episode_number ?? (tmdbItem.isMovie ? -1 : -2),
            notes: note
        });
    }

    return (
        <>
            <ButtonV2 width={50} onClick={() => {
                navigate(customUrl ?? "#notes");
            }} forceDarkMode={forceDarkMode} title={"Abrir Notas"}>
                <i className="fa-regular fa-note-sticky fa-lg"></i>
            </ButtonV2>
            <CustomModalV2 onClose={handleCloseModal} open={location.hash === (customUrl ?? "#notes")} title={
                <div>
                    <div style={{
                        display: "-webkit-inline-box"
                    }}>
                        <div>
                            <FormattedMessage id="tmdb-notepad.modal-title"/>
                        </div>
                        <span
                            style={{fontWeight: "normal", fontSize: "x-small"}}
                            className={"badge ms-2 " + (saving ? "text-bg-info" : "text-bg-success")}>{!saving ?
                            <>
                                Saved&nbsp;<i className="fa-solid fa-check"></i>
                            </> :
                            <>
                                Saving&nbsp;<i className="fa-solid fa-spinner fa-spin"></i>
                            </>}
                        </span>
                    </div>

                    <div>
                        <small className="text-muted" style={{fontWeight: "normal", fontSize: "small"}}>
                            {
                                lastModified
                                    ? getLastModifiedMessage(intl, lastModified)
                                    : <FormattedMessage id="tmdb-notepad.modal-title-description"/>
                            }
                        </small>
                    </div>
                </div>
            }>
                <>
                    <div>
                        <textarea className="form-control" rows="10" value={note}
                                  onChange={e => {
                                      setNote(e.target.value);
                                      setDirty(true);
                                  }}></textarea>
                    </div>
                    <div className="justify-content-start">
                        <small className="text-muted">
                            <FormattedMessage id="tmdb-notepad.modal-warning"/> Puedes acceder a tus notas desde&nbsp;
                            <Link to="/my-profile/private">la zona privada de tu perfil.</Link>
                        </small>
                    </div>
                </>
            </CustomModalV2>
        </>
    )
}

export default TmdbNotepad;
